module.exports = __webpack_public_path__ + "img/icon-round-fb.5b957da1.svg";